module.exports = __webpack_public_path__ + "static/media/main-visual.0f49fe41.jpg";